import React from 'react'
import { Icon } from 'semantic-ui-react'
import '../headerTab/container.css'

const ContainerDetails = ({ item, saveData, updateData, deleteData }) => {
  const { id, containerNum, sealNum, size, qty, weightQty } = item
  
  return (
    <>
      {
        <React.Fragment key={id}>
          <div className='cont_row cont_row--body' style={{ width: '100%' }}>
            <div className='cont_col cont_col--td'>
              <input
                id={`containerNum-${id}`}
                value={containerNum || ''}
                type='text'
                className='cont_input'
                onChange={(e) => updateData(id, { containerNum: e.target.value })}
                onBlur={() => saveData({ id, containerNum: containerNum || ' ' })}
              />
            </div>

            <div className='cont_col cont_col--td'>
              <input
                id={`sealNum-${id}`}
                type='text'
                value={sealNum || ''}
                className='cont_input'
                onChange={(e) => updateData(id, { sealNum: e.target.value })}
                onBlur={(value) => saveData({ id, sealNum: sealNum || ' ' })}
              />
            </div>

            <div className='cont_col cont_col--td'>
              <input
                id={`size-${id}`}
                type='text'
                value={size || ''}
                className='cont_input'
                onChange={(e) => updateData(id, { size: e.target.value })}
                onBlur={(value) => saveData({ id, size: size || ' ' })}
              />
            </div>

            <div className='cont_col cont_col--td'>
              <input
                id={`qty-${id}`}
                type='text'
                className='cont_input'
                value={qty || ''}
                onChange={(e) => updateData(id, { qty: e.target.value })}
                onBlur={(value) => saveData({ id, qty: qty || ' ' })}
              />
            </div>

            <div className='cont_col cont_col--td'>
              <input
                id={`weightQty-${id}`}
                type='text'
                className='cont_input'
                value={weightQty || ''}
                onChange={(e) => updateData(id, { weightQty: e.target.value || ' ' })}
                onBlur={(value) => saveData({id, weightQty: weightQty || ' ',})}
              />
            </div>

            <div className='cont_col cont_col--td'>
              <Icon id={`container-delete-${id}`} name='trash alternate outline' onClick={() => deleteData(id)} />
            </div>
          </div>
        </React.Fragment>
      }
    </>
  )
}

export default React.memo(ContainerDetails)
